import styles from "./DesignBoxTabEditSingle.module.css";
import ProductUrlMap from "../../../ProductUrlMap";
import { useNavigate } from "react-router-dom";
const DesignBoxTabEditSingle = ({ item, activeTabNumber }) => {
  console.log(item, "item from design box tab edit single");

  const navigate = useNavigate();
  const page_route = item?.design?.design_page;
  const saved = item?.design?.design_status === "SAVED";
  const page_link = ProductUrlMap.hasOwnProperty(page_route?.product_code)
    ? "/design-box/" + ProductUrlMap[page_route?.product_code] + "/" + item?.id
    : "/design-box/maintainance";

  if (page_route?.product_code === "pc10") {
    console.log("PostCard");
    console.log(item?.product?.product_type);
    console.log(item?.product?.product_code_jp);
  }

  return (
    <div
      onClick={() => {
        if (activeTabNumber === 1) {
          navigate(page_link);
        } else if (activeTabNumber === 2) {
          navigate("/design-box/edited-preview", {
            state: { item },
          });
        }
      }}
      className={styles.item_container}
    >
      <div className={styles.image_div}>
        {saved && <div className={styles.item_resume}>保存中</div>}
        <img
          width={200}
          height={133}
          src={item?.product?.product_category?.images?.split(",")[0]}
          alt="product"
        />
        {item.quantity > 1 && (
          <div
            className={styles.item_badge}
            style={{
              height: item?.quantity > 99 ? "36px" : "22px",
              width: item?.quantity > 99 ? "36px" : "22px",
            }}
          >
            <div
              style={{
                paddingTop: item?.quantity > 99 ? "6px" : "0px",
              }}
              className={styles.item_badge_text}
            >
              {item?.quantity}
            </div>
          </div>
        )}
      </div>
      <div className={styles.item_text_div}>
        <div className={styles.item_text_1}>
          {item?.product.product_category?.name}
        </div>
        <div className={styles.item_text_2}>
          {item?.product?.product_type + " " + item.product.size_page}
        </div>
      </div>
    </div>
  );
};
export default DesignBoxTabEditSingle;
